<template>
<div id="app">
	<div class="rya-training-timeline">
		<div class="timeline-header">
			<img v-on:click.prevent="toggleTimeline" class="timeline-icon" :src="imageUrl + '/rya-50-years-training-logo.svg'" alt="50 Years of RYA Training">
			<StartScreen :clickedStart="clickedStart" :toggleTimeline="toggleTimeline" :isError="isError" :imageUrl="imageUrl"/>
			<div class="nav">
				<div class="splide " id="secondary-slider">
					<div class="splide__track">
						<ul class="splide__list">
							<span class="splide__slide nav-item" v-for="year in data" :key="year.date">{{year.date}}</span>
						</ul>
					</div>
				</div>
				<hr>
				<p class="nav-tip">Swipe or click the arrows to navigate </p>
			</div>
		</div>
		<div class="timeline-content-area">
			<div class="splide " id="primary-slider">
				<div class="splide__track">
					<ul class="splide__list" >
						<div class="splide__slide temp-one" v-for="year in data" :key="year.date">
							<div class="contentblock-holder" v-for="(block, index) in year.contentBlocks" :key="index">
								<div class="nine-by-six-img" v-if="block.blockType === 'nine by six'">
									<img :src="imageUrl + block.images" :alt="block.text">
									<p>{{block.text}}</p>
								</div>

								<div class="six-by-nine-img" v-if="block.blockType === 'six by nine'">
									<img :src="imageUrl + block.images[0]" :alt="block.text">
									<p>{{block.text}}</p>
								</div>

								<div class="six-by-nine-img img-array" v-if="block.blockType === 'six by nine image array'">
									<div v-for="image in block.images" :key="image">
										<img :src="imageUrl + image" :alt="block.text">
									</div>
									
								</div>

								<div class="text-no-img" v-if="block.blockType === 'text no image'">                   
									<p>{{block.text}}</p>
								</div>

								<div class="two-img" v-if="block.blockType === 'two image'">
										<img :src="imageUrl + block.images[0]" :alt="block.text">
										<img :src="imageUrl + block.images[1]" :alt="block.text">
										<p>{{block.text}}</p>
								</div>

								<div class="text-no-img-list" style="max-width: none;" v-if="block.blockType === 'text no image list'">
                                    <ul>
                                        <li v-for="bullet in block.text" :key="bullet">{{bullet}}</li>
                                    </ul>
                                </div>
								<hr class="contentblock-divider">
							</div>
						</div>
					</ul>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';

import StartScreen from './components/StartScreen.vue'

export default {
	name: 'App',
	components: {
		StartScreen
	},
	data() {
		return{
			data: [],
			loaded: false,
			clickedStart: false,
			isError: false,
			// imageUrl value for Sitecore "/-/media/apps/[folder name here]"
			imageUrl: "",
			config: undefined
		}
	},
	created: function() {},
	mounted() {
        // checks confige object on page
		if(window.timelineConfig || this.config == 'undefined') {
            this.config = window.timelineConfig;

			if(this.config.imageUrl) {
				this.imageUrl = this.config.imageUrl;
			} else {
				console.error('Cannot find image locations, please check images within media library')
				this.isError = true
			}
			
        } else {
            console.error('Timeline Config object cannot be found on page, please check the inline script')
			this.isError = true
        }

		fetch(this.config.jsonUrl)
		.then((response) => response.json())
		.then(jsonData => {
			this.data = jsonData;
			this.loaded = true
		})
		.catch(error => {
			console.error('Cannot read from JSON file. Please check the URL is correct in the config object and that the file have not been mored or deleted', error);
			this.isError = true
		})
	},
	methods: {
		mountSlick: function() {
			var secondarySlider = new Splide ( '#secondary-slider', {
				fixedWidth: 100,
				rewind: true,
				gap: 10,
				pagination: false,
				isNavigation: true,
				focus: 'center',
				padding: {
					right: '0em',
					left: '0em',
				},
				breakpoints: {
					'600': {
						fixedWidth: 66,
						height: 40,
					}
				}
			}).mount();

			var primarySlider = new Splide( '#primary-slider', {
				type: 'fade',
				pagination: false,
				arrows: false,
				cover: true,
				preloadPages: 2
			});

			primarySlider.sync( secondarySlider ).mount();
		},
		checkData: function() {
			setTimeout(()=>{
				if(this.data.length > 2) {
					this.mountSlick()
				} else {
					this.checkData()
				}
			}, 1000)
		},
		toggleTimeline: function() {
			if(this.clickedStart) {
				this.clickedStart = false
			} else {
				this.clickedStart = true
			}
		}
	},
	watch: {
		loaded: function() {
			this.checkData()
		},
    }
}


</script>

<style lang="scss">
	#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	// margin-top: 60px;
	}
</style>
